export const DEFAULT_PORTAL_ROLE = 'member';
export const NO_ACCESS_PORTAL_ROLE = 'no_access';

export const FD_USER_TYPE_TO_PYLON_USER_TYPE: Record<
  'manager' | 'tenant' | 'underwriter',
  'property manager' | 'applicant' | 'underwriter'
> = {
  manager: 'property manager',
  tenant: 'applicant',
  underwriter: 'underwriter',
};
